import { render, staticRenderFns } from "./Holerite.vue?vue&type=template&id=b9421bbe"
import script from "./Holerite.vue?vue&type=script&lang=js"
export * from "./Holerite.vue?vue&type=script&lang=js"
import style0 from "./Holerite.vue?vue&type=style&index=0&id=b9421bbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports